import { axiosInstance } from 'utils/http';
import { cleanRoom } from 'utils/urlConstants';
import { showAlert } from 'redux/actions/AlertActions';
import { useDispatch, useSelector } from 'react-redux';
import { useMutation, useQueryClient } from 'react-query';
import { useState } from 'react';


export const useDeleteCrqConfigParam = (crId, crqId) => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();
  const [errorMsg, setErrorMsg] = useState();
  const orgId = useSelector(state => state.session.user.primaryOrganization.organization.ID);

  const {
    isLoading, isError, isSuccess, mutate, mutateAsync,
  } = useMutation(({ paramName }) => axiosInstance
    .delete(cleanRoom(orgId).deleteCrqConfigParameter(crId, crqId, paramName)),
  {
    onSuccess: () => {
      queryClient.invalidateQueries(['getCleanroomQuestionV2', orgId, crId]);
      queryClient.invalidateQueries(['getCrQuestionConfigParams', crId, crqId]);
      dispatch(showAlert({
        message: 'Clean room question parameter deleted.',
        type: 'success',
      }));
    },
    onError: (err) => {
      dispatch(showAlert({
        message: err.response.data.message,
        type: 'error',
      }));
      setErrorMsg(err.response.data.message);
    },
  },
  );

  return {
    errorMsg,
    isLoading,
    isSuccess,
    isError,
    mutate,
    mutateAsync,
  };
};
